<template>
    <div class="huaaiLoading">
        <dl class="tips">
            <dt><img src="../../../assets/images/normal/huacaiLogo.png" alt=""></dt>
            <dd>
                <p>即将进入华彩证券…</p>
            </dd>
        </dl>
        <dl class="notice">
            <dt>
                投米平台作为导流平台为华彩证券提供链接跳转等信息展示辅助服务，华彩证券有限公司（简称“华彩证券”）是香港证监会认可的持牌法团（中央编号AWF639）。持有香港证监会：第1类“证券交易”和第2类“期货合约交易”牌照。 开户及交易服务均由华彩证券提供。
                点击确认授权，视为同意将您的用户信息（包括用户ID、手机号、理财师ID ）授权给华彩证券使用。
            </dt>
            <dd>请阅读以下文件，点击确认视为同意授权:<br /><a :href="url">《用户信息使用授权协议》</a></dd>
            <dd><a href="javascript:void(0)" class="btn" @click="confirm">确认授权</a></dd>
        </dl>
    </div>
</template>
<script>
    import {callHandler} from "../../../utils/bridge";
    import {request} from "../../../utils/request"

    export default {
        data() {
            return {
                pending: false,
                url: ''
            };
        },
        created() {
            const {token} = this.$route.query;
            this.token = decodeURIComponent(token || "");
            this.url = '#/mergerAgreement?type=huacai&token=' + this.token;
        },
        methods: {
            confirm() {
                if (this.pending) {
                    return
                }
                this.pending = true;
                request({
                    url: "/h5/huacai/saveAuthorize",
                    data: this.$qs.stringify({
                        token: this.token
                    })
                }).then((res) => {
                    this.pending = false;
                    const {code, msg} = res;
                    if (code !== '1') {
                        this.$toast(msg);
                    } else {
                        callHandler("xhWapGoBack", "wapCloseWeb");
                    }
                }).catch(err => {
                    this.pending = false;
                    this.$toast(err);
                });
            }
        }
    };
</script>
<style lang="less">
    body {
        margin: 0;
        background: #ffffff;
    }

    .huaaiLoading {
        .tips {
            text-align: center;
            padding-top: 140px;

            dt {
                img {
                    width: 48px;
                    height: 48px;
                }
            }

            dd {
                padding-top: 24px;
                line-height: 24px;
                font-size: 14px;
                color: #333333;

                span {
                    color: #C4A06C;
                    margin: 0 6px;
                }
            }
        }

        .notice {
            padding: 32px 16px 0;

            dt {
                color: #c6c6c6;
                font-size: 10px;
                line-height: 14px;
                letter-spacing: -.3px;
                text-align: justify;
            }

            dd {
                padding-top: 20px;
                font-size: 12px;
                a {
                    color: #C0A266;
                    font-size: 12px;
                }
                .btn {
                    display: block;
                    height: 44px;
                    line-height: 44px;
                    background-image: linear-gradient(90deg, #D0B77B 0%, #B89659 100%);
                    border-radius: 4px;
                    font-size: 16px;
                    color: #FFFFFF;
                    text-align: center;
                }
            }
        }

    }
</style>
